module.exports = __webpack_public_path__ + "img/ordToning2.46050f2e.jpg";